<template>
  <div class="mk-left">
    <div class="search">
      <Input @on-enter="getData" v-model="keywords" prefix="ios-search" placeholder="搜索患者" />
    </div>
    <div class="tab">
      <Tabs v-model="expertiseType" @on-click="getData">
        <TabPane :label="label1" name="1" v-if="showTabPane"></TabPane>
        <TabPane :label="label2" name="2"></TabPane>
        <TabPane :label="label3" name="4" v-if="showTabPane2"></TabPane>
        <TabPane :label="label4" name="6" v-if="showTabPane3"></TabPane>
      </Tabs>
    </div>
    <div class="tip">
      <template v-if="expertiseType == '1'">
        <span class="text t1">待收集<i>—等待助手补充病情信息</i></span>
        <span class="text t2">可回复<i>—可回复医生</i></span>
      </template>
      <span v-if="expertiseType == '6'" class="text t3">待补充<i>—等待补充治疗方案</i></span>
    </div>
    <div class="list" ref="listRef">
      <Scroll :on-reach-bottom="handleReachBottom" :height="scrollHeight" :expertiseType="expertiseType">
        <div class="item" :class="{ active: activeItem == item }" v-for="(item, index) in list" :key="index"
          @click="selectItem(item)">
          <div class="icon">
            <i v-if="item.sex == '女'" class="iconfont icon-morennvtouxiang"></i>
            <i v-else class="iconfont icon-morennantouxiang"></i>
          </div>
          <div class="info">
            <div class="fjcsb">
              <div class="name ellipsis">{{ item.patientName }}</div>
              <div class="">{{ item.diseaseName }}</div>
            </div>
            <div class="fjcsb other" v-if="expertiseType != '4'">
              <div class="">
                医生:{{
                  expertiseType == "1"
                    ? item.doctorName
                    : item.benchmarkDoctorName
                }}
              </div>
              <div class="time">
                <template v-if="expertiseType == '6'">
                  <span v-if="item.supplementType == '2'" class="tag tag2">待补充</span>
                  <span v-else-if="item.supplementType == '1'" class="tag tag3">已完成</span>
                </template>
                <template v-else>
                  <span v-if="item.dotType == 2" class="tag tag1">可回复</span>
                  <span v-else-if="item.dotType == 1" class="tag tag2">待收集</span>
                  <span v-else-if="item.dotType == 0" class="tag tag3">已完成</span>
                </template>
                {{ item.consultDate }}
              </div>
            </div>
          </div>

          <!-- {{ expertiseType }}{{ item.readFlg }} -->
          <div class="new" v-if="expertiseType == '2' && !item.readFlg">
            <Badge status="error" />
          </div>

          <!-- 
          <div class="new">
            <Badge status="error" v-if="
              expertiseType == '6'
                ? item.supplementType == '2' // 2有红点 1没红点
                : ['1'].includes(expertiseType)
                  ? !item.benchmarkReadFlg
                  : !item.readFlg
            " />
          </div> 
          -->
        </div>
        <empty v-if="lastPage" text="没有更多了" />
        <div class="empty tip" v-else @click="handleReachBottom">
          滚动或点击加载更多
        </div>
      </Scroll>
      <empty v-if="list.length == 0" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showTabPane: true,
      showTabPane2: false,
      expertiseType: "1", //	数据类型 1 咨询我的 2 我咨询的 3 开处方
      keywords: "",
      list: [],
      label1: null,
      label2: null,
      label3: null,
      label4: null,
      tabVal: "1",
      activeItem: {},
      pageIndex: 1,
      pageSize: 15,
      lastPage: false, //是否最后一页
      scrollHeight: 100,
    };
  },
  computed: {
    ...mapGetters(["todoNumber", "dicts", "userInfo"]),
    MEDICAL_EXPERTISE() {
      let list = this.dicts.MEDICAL_EXPERTISE || [];
      return list.find((item) => item.label == this.userInfo.husDoctorId) || {};
    },
    showTabPane3() {
      return this.MEDICAL_EXPERTISE.string7 == "1";
    },
  },
  methods: {
    selectItem(item) {
      this.activeItem = item;
      this.emit();
    },
    emit() {
      this.$emit("selectItem", this.activeItem);
    },
    setLabel() {
      this.label1 = (h) => {
        return h("div", [
          h("span", "咨询我的"),
          h("Badge", {
            props: {
              count: this.todoNumber.medicalExpertiseDot.num1,
            },
          }),
        ]);
      };
      this.label2 = (h) => {
        return h("div", [
          h("span", "我咨询的"),
          h("Badge", {
            props: {
              count: this.todoNumber.medicalExpertiseDot.num2,
            },
          }),
        ]);
      };
      this.label3 = (h) => {
        return h("div", [
          h("span", "预备方案"),
          h("Badge", {
            props: {
              count: this.todoNumber.medicalExpertiseDot.num3,
            },
          }),
        ]);
      };
      this.label4 = (h) => {
        return h("div", [
          h("span", "方案补充"),
          h("Badge", {
            props: {
              count: this.todoNumber.medicalExpertiseDot.num4,
            },
          }),
        ]);
      };
    },
    handleReachBottom() {
      if (this.lastPage) {
        return Promise.resolve();
      }
      this.pageIndex++;
      return this.getDataFun();
    },
    getData() {
      this.list = [];
      this.lastPage = false;
      this.pageIndex = 1;
      this.getDataFun();
    },
    getDataFun() {
      return new Promise((resolve, reject) => {
        let obj = {
          keywords: this.keywords,
          expertiseType: this.expertiseType, //	数据类型 1 咨询我的 2 我咨询的 3 开处方 6 方案补充
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          patientCode: "",
        };
        this.request
          .post("/zhbusiness/getYzMedicalExpertiseList", obj)
          .then((res) => {
            this.lastPage = res.pageCount <= this.pageIndex;
            if (res.result.length > 0) {
              this.list = this.list.concat(
                res.result.map((i) => {
                  i.expertiseType = this.expertiseType;
                  return i;
                })
              );
            } else {
              this.list = [];
              if (
                this.expertiseType == 1 &&
                this.MEDICAL_EXPERTISE.string4 == "0"
              ) {
                this.expertiseType = "2";
                this.getData();
                this.showTabPane = false;
              }
            }

            if (this.list.length > 0) {
              this.selectItem(this.list[0]);
            } else {
              this.selectItem("");
            }

            resolve(res.result);
          })
          .catch(reject);
      });
    },
    refresh(res) {
      let item = this.list.find((i) => i.meId == res.meId);
      if (item) {
        this.expertiseType == "1"
          ? (item.benchmarkReadFlg = 0)
          : (item.readFlg = 0);
        if (res.isNew) {
          item.planFlg = 0;
        }
      }
    },
    getMedicalExpertiseData() {
      this.api2("getMedicalExpertiseData", {
        dataType: 2,
      }).then((res) => {
        this.showTabPane2 = res.result
          .map((i) => i.doctorId)
          .includes(this.userInfo.husDoctorId);
      });
    },
  },
  created() {
    this.$store
      .dispatch("getWideUseList", { key: "MEDICAL_EXPERTISE", type: "saas" })
      .then(() => {
        this.getData();
        this.getMedicalExpertiseData();
        this.setLabel();
      });
  },
  mounted() {
    this.$bus.on("MEMessage", this.refresh);
    this.scrollHeight = this.$refs.listRef.clientHeight;
  },
  beforeDestroy() {
    this.$bus.off("MEMessage", this.refresh);
  },
};
</script>

<style lang="scss" scoped>
.mk-left {
  height: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;

  .tab {
    height: 54px;
  }

  :deep {
    .ivu-scroll-content {
      .empty {
        padding: 10px 0;
      }
    }

    .ivu-tabs-nav .ivu-tabs-tab {
      padding-left: 0;
      padding-right: 0;
      font-weight: bold;
      font-size: 15px;
    }

    .list {
      height: 100%;
      overflow: hidden;

      .tip {
        cursor: pointer;
      }

      .item {
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        padding: 8px 10px;
        border-radius: 5px;

        &.active {
          background: #f5f5f5;
        }

        .info {
          width: 100%;

          .other {
            font-size: 13px;
          }
        }

        .icon {
          margin-right: 10px;

          .iconfont {
            font-size: 20px;
          }
        }

        .name {
          font-weight: bold;
          margin-right: 15px;
          max-width: 70px;
        }

        .time {
          overflow: hidden;
          white-space: nowrap;
          color: #999;
          margin-left: auto;

          .tag {
            padding-right: 10px;

            &.tag1 {
              color: green;
            }

            &.tag2 {
              color: red;
            }

            &.tag3 {
              opacity: 0.6;
            }
          }
        }

        .new {
          padding-left: 10px;
          width: 18px;
          height: 20px;
          overflow: hidden;
          flex-shrink: 0;
        }
      }
    }
  }

  .tip {
    font-size: 12px;
    gap: 10px;
    display: flex;

    i {
      font-style: normal;
      opacity: 0.6;
    }

    .text {
      display: inline-block;

      &::before {
        content: ' ';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #b20000;
        margin-right: 5px;
      }

      &.t1 {
        &::before {
          background: #b20000;
        }
      }

      &.t2 {
        &::before {
          background: #00b300;
        }
      }

      &.t3 {
        &::before {
          background: #0000b3;
        }
      }
    }
  }
}
</style>